

// import { Button } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../AuthContext";
// import { useEffect, useState } from "react";

// const JoinButton = ({ postId, hostUserId, title, hostName, date, startTime, duration }) => {
//   const navigate = useNavigate();
//   const { userId } = useAuth();

//   const [isLive, setIsLive] = useState(false);

//   useEffect(() => {
//     const checkTime = () => {
//   if (!date || !startTime || !duration) return;

//   const now = new Date();

//   // ✅ extract time properly
//   const [hours, minutes] = startTime.split(":");

//   // ✅ FIX: create local date (NO timezone bug)
//   const [year, month, day] = date.split("-");

//   const sessionStart = new Date(
//     Number(year),
//     Number(month) - 1,
//     Number(day),
//     Number(hours),
//     Number(minutes)
//   );

//   // ✅ FIX: convert duration to number
//   const durationMinutes = parseFloat(duration);

//   const sessionEnd = new Date(sessionStart);
//   sessionEnd.setMinutes(sessionEnd.getMinutes() + durationMinutes);

//   console.log("NOW:", now);
//   console.log("START:", sessionStart);
//   console.log("END:", sessionEnd);

//   setIsLive(now >= sessionStart && now <= sessionEnd);
// };
//     checkTime();
//     const interval = setInterval(checkTime, 1000); // check every second

//     return () => clearInterval(interval);
//   }, [date, startTime, duration]);

//   const handleJoin = () => {
//      if (!postId || !isLive) return;  // already guards postId, but add a log:
//   console.log("Navigating with post_id:", postId);
//     const isHost = userId === hostUserId;
//     const role = isHost ? "host" : "audience";

//     const slug = title
//       ?.toLowerCase()
//       .replace(/[^a-z0-9]+/g, "-")
//       .replace(/(^-|-$)/g, "") || "session";

//     navigate(`/live/${slug}?role=${role}&post_id=${postId}`, {
//       state: { hostName },
//     });
//   };

//   return (
//     <Button
//       variant="contained"
//       onClick={handleJoin}
//       disabled={!isLive}
//       sx={{
//         borderRadius: "20px",
//         px: 4,
//         py: 1.5,
//         fontWeight: 600,
//         textTransform: "none",

//         // 🎨 COLOR LOGIC
//        backgroundColor: isLive ? "#22c55e" : "#9e9e9e", // green : grey
//         color: "#fff",

//         // hover only when live
//         "&:hover": {
//   backgroundColor: isLive ? "#16a34a" : "#9e9e9e",
// },

//         // smooth transition
//         transition: "all 0.3s ease",

//         // optional slight fade
//         opacity: isLive ? 1 : 0.7,
//       }}
//     >
//       {isLive ? "Join Session" : "Join Session (Not Live)"}
//     </Button>
//   );
// };

// export default JoinButton;


import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { useEffect, useState } from "react";

const JoinButton = ({ postId, hostUserId, title, hostName, date, startTime, duration }) => {
  const navigate = useNavigate();
  const { userId } = useAuth();

  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    const checkTime = () => {
  if (!date || !startTime || !duration) return;

  const now = new Date();

  // ✅ extract time properly
  const [hours, minutes] = startTime.split(":");

  // ✅ FIX: create local date (NO timezone bug)
  const [year, month, day] = date.split("-");

  const sessionStart = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(minutes)
  );

  // ✅ FIX: convert duration to number
  const durationMinutes = parseFloat(duration);

  const sessionEnd = new Date(sessionStart);
  sessionEnd.setMinutes(sessionEnd.getMinutes() + durationMinutes);

  console.log("NOW:", now);
  console.log("START:", sessionStart);
  console.log("END:", sessionEnd);

  setIsLive(now >= sessionStart && now <= sessionEnd);
};
    checkTime();
    const interval = setInterval(checkTime, 1000); // check every second

    return () => clearInterval(interval);
  }, [date, startTime, duration]);

  const handleJoin = () => {
     if (!postId || !isLive) return;  // already guards postId, but add a log:
  console.log("Navigating with post_id:", postId);
    const isHost = userId === hostUserId;
    const role = isHost ? "host" : "audience";

    const slug = title
      ?.toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "") || "session";

    navigate(`/prejoin?channel=${slug}&role=${role}&host_name=${hostName}&post_id=${postId}`);
  };

  return (
    <Button
      variant="contained"
      onClick={handleJoin}
      disabled={!isLive}
      sx={{
        borderRadius: "20px",
        px: 4,
        py: 1.5,
        fontWeight: 600,
        textTransform: "none",

        // 🎨 COLOR LOGIC
       backgroundColor: isLive ? "#22c55e" : "#9e9e9e", // green : grey
        color: "#fff",

        // hover only when live
        "&:hover": {
  backgroundColor: isLive ? "#16a34a" : "#9e9e9e",
},

        // smooth transition
        transition: "all 0.3s ease",

        // optional slight fade
        opacity: isLive ? 1 : 0.7,
      }}
    >
      {isLive ? "Join Session" : "Join Session (Not Live)"}
    </Button>
  );
};

export default JoinButton;